import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import SkeletonBox from '../../UI/SkeletonBox/SkeletonBox';
import SkeletonContent from './SkeletonContent';

const useStyles = createUseStyles({
  skeletonSection: {
    backgroundColor: '#fff',
    padding: 16,
    margin: [16, 0],
  },
  header: {
    marginBottom: 16,
  },
});

export default function SkeletonSection(props) {
  const classes = useStyles();
  
  return (
    <section className={classes.skeletonSection}>
      <div className={classes.header}>
        <SkeletonBox height={21} width="50%" />
      </div>
      <SkeletonContent step={props.step} />
    </section>
  );
}

SkeletonSection.propTypes = {
  step: PropTypes.number,
};
